export const POLICIES = [
  {
    id: '1',
    items: [
      {
        id: '1'
      },
      {
        id: '2'
      },
      {
        id: '3'
      },
      {
        id: '4'
      },
      {
        id: '5'
      },
      {
        id: '6'
      },
      {
        id: '7'
      }
    ]
  },
  {
    id: '2',
    items: [
      {
        id: '1'
      },
      {
        id: '2'
      },
      {
        id: '3'
      },
      {
        id: '4'
      },
      {
        id: '5'
      },
      {
        id: '6'
      },
      {
        id: '7'
      },
      {
        id: '8'
      },
      {
        id: '9'
      }
    ]
  },
  {
    id: '3',
    items: [
      {
        id: '1'
      },
      {
        id: '2',
        items: [
          {
            id: '1'
          },
          {
            id: '2'
          }
        ]
      },
      {
        id: '3'
      },
      {
        id: '4'
      }
    ]
  },
  {
    id: '4',
    items: [
      {
        id: '1',
        items: [
          {
            id: '1'
          }
        ]
      },
      {
        id: '2'
      },
      {
        id: '3',
        items: [{ id: '1' }, { id: '2' }]
      },
      {
        id: '4',
        items: [{ id: '1' }]
      }
    ]
  },
  {
    id: '5',
    items: [
      {
        id: '1'
      },
      {
        id: '2'
      },
      {
        id: '3'
      }
    ]
  },
  {
    id: '6',
    items: [
      {
        id: '1'
      }
    ]
  },
  {
    id: '7',
    items: [
      {
        id: '1'
      }
    ]
  },
  {
    id: '8',
    items: [
      {
        id: '1'
      },
      {
        id: '2',
        items: [
          {
            id: '1'
          },
          {
            id: '2'
          },
          {
            id: '3'
          },
          {
            id: '4'
          },
          {
            id: '5'
          },
          {
            id: '6'
          },
          {
            id: '7'
          }
        ]
      },
      {
        id: '3'
      },
      {
        id: '4'
      }
    ]
  },
  {
    id: '9',
    items: [
      {
        id: '1',
        items: [
          {
            id: '1'
          },
          {
            id: '2'
          }
        ]
      },
      {
        id: '2'
      }
    ]
  },
  {
    id: '10',
    items: [
      {
        id: '1'
      },
      {
        id: '2'
      },
      {
        id: '3'
      }
    ]
  },
  {
    id: '11',
    items: [
      {
        id: '1',
        items: [
          {
            id: '1'
          },
          {
            id: '2'
          },
          {
            id: '3'
          }
        ]
      }
    ]
  }
]
